__turbopack_context__.v({
  "disabled": "addPlaceholderTile-module-scss-module__l7GMqG__disabled",
  "placeholder": "addPlaceholderTile-module-scss-module__l7GMqG__placeholder",
  "placeholderBtn": "addPlaceholderTile-module-scss-module__l7GMqG__placeholderBtn",
  "placeholderBtnContainer": "addPlaceholderTile-module-scss-module__l7GMqG__placeholderBtnContainer",
  "placeholderLabel": "addPlaceholderTile-module-scss-module__l7GMqG__placeholderLabel",
  "plusSign": "addPlaceholderTile-module-scss-module__l7GMqG__plusSign",
});
